module.exports = __webpack_public_path__ + "img/contact-img.a7efa5b6.png";